import { render, staticRenderFns } from "./Website.vue?vue&type=template&id=5181d893&"
import script from "./Website.vue?vue&type=script&lang=js&"
export * from "./Website.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports